/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import type React from 'react';

import COLORS from '@/constants/colors';

/**
 * Bandeau rouge des trois modales de mention (saisie, modification,
 * suppression).
 *
 * Constante de module et non objet recréé dans le corps de chaque composant : la
 * référence est stable d'un render à l'autre, et le style ne peut plus diverger
 * d'une modale à l'autre.
 *
 * Posé ici plutôt que dans `components/Common` : les seuls consommateurs sont
 * les modales voisines, et le barrel de `Common` réexporte
 * `ModalRegistreTreeView` — donc `administres-utils`, que jest ne transforme pas
 * (les tests des modales de mention ne le mockent pas).
 */
const MODAL_HEADER_STYLE: React.CSSProperties = {
  backgroundColor: COLORS.RedListColor,
  color: 'white',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export default MODAL_HEADER_STYLE;
